export const validateProteinPercentage = (protein: string, minValue: number, maxValue: number) => {
  const num = Number(protein)

  return !!protein && !Number.isNaN(num) && num >= minValue && num <= maxValue
}
